import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Button,
  Grid,
  SvgIcon,
  Typography,
  Input,
  Box,
} from '@material-ui/core';
import {
  PlusCircle as PlusCircleIcon,
  X as XIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  Trash2 as TrashIcon,
} from 'react-feather';

import { useSnackbar } from 'notistack';
import useStyles from './styles';
import { getSubcategoriesExport } from '../../../requests/api/subcategories';
import { uploadSubcategoriesFile } from '../../../requests/api/categories';

function Header({
  className,
  cleanFilters,
  ...rest
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);

  const handleExport = async () => {
    setLoadingExport(true);
    enqueueSnackbar('Los datos se están preparando para ser descargados', {
      variant: 'success',
      autoHideDuration: 5000,
    });

    try {
      const { data } = await getSubcategoriesExport();
      if (data?.data?.file) {
        const fileData = data.data.file;
        const uri = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;base64,${fileData}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = uri;
        downloadLink.download = 'file.xlsx';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        enqueueSnackbar(data?.errorMessage || 'Error desconocido', {
          variant: 'error',
        });
      }
    } catch (error) {
      enqueueSnackbar('Error al descargar el archivo', {
        variant: 'error',
      });
    } finally {
      setLoadingExport(false);
    }
  };

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoadingUpload(true);
    enqueueSnackbar('Subiendo archivo...', {
      variant: 'info',
      autoHideDuration: 5000,
    });

    try {
      const response = await uploadSubcategoriesFile(file);
      if (response.success) {
        enqueueSnackbar('Archivo subido exitosamente', {
          variant: 'success',
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar(response?.message || 'Error desconocido', {
          variant: 'error',
        });
      }
    } catch (error) {
      enqueueSnackbar('Error al subir el archivo', {
        variant: 'error',
      });
    } finally {
      setLoadingUpload(false);
    }
  };

  return (
    <Grid
      className={clsx(classes.rootHeader, className)}
      container
      justifyContent="space-between"
      spacing={3}
      alignItems="center"
      {...rest}
    >
      <Grid item xs={12} md={4}>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          Subcategorías
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Box style={{
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
        }}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => cleanFilters()}
            style={{ width: '200px' }}
          >
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <XIcon />
            </SvgIcon>
            Limpiar filtros
          </Button>
          <Button
            color="secondary"
            variant="contained"
            href="/config/subcategories/crear"
            style={{ width: '250px' }}
          >
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <PlusCircleIcon />
            </SvgIcon>
            Agregar Subcategoría
          </Button>
          <Button
            color="secondary"
            variant="contained"
            href="/config/subcategories/inactive"
            style={{ width: '270px' }}
          >
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <TrashIcon />
            </SvgIcon>
            Subcategorías eliminadas
          </Button>
        </Box>
      </Grid>
      <Grid item xs={3} md={3} className={classes.actionContainer}>
        <Button
          color="primary"
          variant="contained"
          className={classes.action}
          onClick={handleExport}
          disabled={loadingExport}
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <DownloadIcon />
          </SvgIcon>
          Descargar archivo base
        </Button>
        <Input
          type="file"
          style={{ display: 'none' }}
          id="upload-file"
          onChange={handleUpload}
        />
        <label htmlFor="upload-file">
          <Button
            color="primary"
            variant="contained"
            className={classes.action}
            component="span"
            disabled={loadingUpload}
          >
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <UploadIcon />
            </SvgIcon>
            Subir archivo url
          </Button>
        </label>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  cleanFilters: PropTypes.func,
};

export default Header;
